import './index.css';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root') as HTMLElement;

const app = (
    <React.StrictMode>
        <ErrorBoundary fallback={<div>Something went wrong</div>}>
            <App />
        </ErrorBoundary>
    </React.StrictMode>
);

// When the page was pre-rendered by react-snap, hydrate the existing markup
// instead of throwing it away. Otherwise mount fresh (dev / fallback).
if (rootElement.hasChildNodes()) {
    ReactDOM.hydrateRoot(rootElement, app);
} else {
    ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
